<template>
  <RsModal
    :value="showModal"
    modal-class="rs-modal-validation-summary"
    :show-main-footer="false"
    scrollable
    @input="handleClose"
  >
    <template #modalTitle>
      <div class="d-flex align-items-center">
        <i class="fas fa-exclamation-circle rs-text-error mr-2" />
        <h4 class="mb-0">
          There were errors submitting your changes
        </h4>
      </div>
    </template>

    <p>
      The following requirements are missing:
    </p>

    <div
      v-for="(key, index) in Object.keys(errors)"
      :key="`${key}-${index}`"
      class="mb-2 error-leaf py-2 px-3 bg-light rounded"
    >
      <div>
        {{ key }}
      </div>
      <div
        v-for="(error, errorIndex) in (errors as Record<string, string[]>)[key]"
        :key="`${key}-${index}-error-${errorIndex}`"
        class="small font-weight-normal ml-3 rs-text-error d-flex align-items-center"
      >
        <i class="fas fa-exclamation-circle mr-2" />
        <div>{{ error }}</div>
      </div>
    </div>
  </RsModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { validationSummary } from '@/store/typed/typed-modules';
import { mapModuleActions, mapModuleGetters } from '@/shared/vuex-toolkit';

export default defineComponent({
  computed: {
    ...mapModuleGetters(validationSummary, ['showModal', 'errors']),
  },

  methods: {
    ...mapModuleActions(validationSummary, ['dismissSummary']),

    handleClose() {
      this.dismissSummary({});
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.error-leaf {
  border-left: solid 6px $error;
}
</style>

<!--
  Unscoped: the backdrop below is rendered by RsModal, so a scoped selector
  would never reach it.
-->
<style lang="scss">
/*
  This summary is a global reporter that can be raised from inside another modal
  (the translations modal does exactly that). Every RsModal teleports to <body>
  at the same Bootstrap z-index, so with equal stacking the later-teleported node
  wins — and this one mounts first, in App.vue, which left it painting underneath
  the very modal whose errors it was reporting. Raise the dialog and its backdrop
  above $zindex-modal (1050) / $zindex-modal-backdrop (1040) so it always wins.

  `.modal` is qualified deliberately: main.ts imports App.vue before
  bootstrap.css, so Bootstrap's own `.modal { z-index: 1050 }` is injected after
  every SFC style and would win a single-class tie on source order alone.
*/
.modal.rs-modal-validation-summary {
  z-index: 1070;

  + .modal-backdrop {
    z-index: 1060;
  }
}
</style>
